
const StatusBadge = ({ status }) => {
  const styles = {
    Active: "text-green-600 bg-green-100 border border-green-300",
    Completed: "text-blue-600 bg-blue-100 border border-blue-300",
    Cancelled: "text-red-600 bg-red-100 border border-red-300",
    Draft: "text-yellow-600 bg-yellow-100 border border-yellow-300",
  };

  return (
    <span className={`px-3 py-1 rounded-full text-xs font-medium ${styles[status]}`}>
      {status}
    </span>
  );
};

export default StatusBadge
